import { render, staticRenderFns } from "./PaqImagen.vue?vue&type=template&id=7732091c&scoped=true"
import script from "./PaqImagen.vue?vue&type=script&lang=js"
export * from "./PaqImagen.vue?vue&type=script&lang=js"
import style0 from "./PaqImagen.vue?vue&type=style&index=0&id=7732091c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7732091c",
  null
  
)

export default component.exports